import * as yup from 'yup';

export const LookupFieldsSetupValidationSchema = yup.object({
  name: yup
    .string()
    .required("Name is required")
    .min(3, "Minimum length 3 characters")
    .max(50, "Maximum length 50 characters"),
});
